import React, { useState, useRef, useEffect } from 'react';
import './CustomDropdown.scss';

interface OptionType {
  value: string;
  icon: React.ReactNode;
}

interface CustomDropdownProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: OptionType[];
  icon: React.ReactNode;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ label, value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = (optionValue: string) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Find the current selected option
  const selectedOption = options.find((option) => option.value === value);

  return (
    <div className='setting-item' ref={dropdownRef}>
      <label className='setting-label'>{label}</label>
      <div className='setting-control'>
        <div className={`custom-dropdown-select ${isOpen ? 'active' : ''}`} onClick={handleToggle}>
          <div className='selected-option'>{selectedOption?.icon}</div>
          {/* <div className='dropdown-arrow'></div> */}
          <span className={`fas fa-caret-down pl-[2px] w-[17px] h-[17px]`} />
        </div>

        {isOpen && (
          <div className='dropdown-options'>
            {options.map((option) => (
              <div
                key={option.value}
                className={`dropdown-option ${value === option.value ? 'selected' : ''}`}
                onClick={() => handleOptionClick(option.value)}
              >
                {option.icon}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomDropdown;
